/**
 * ShortLinkRedirect — invisible catch-all for storylo.co.uk/{shortSlug}.
 * Resolves the slug via the API (which records the click analytics) and
 * immediately replaces the location with the story page. No intermediate
 * page, no loader — unknown slugs fall through to the home gallery.
 */
import { useEffect } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ShortLinkRedirect({ slug }) {
  useEffect(() => {
    let cancelled = false;
    const ref = encodeURIComponent(document.referrer || "");
    const url = `${API}/shortlinks/resolve/${encodeURIComponent(slug)}?ref=${ref}`;
    // Retry through transient 5xx blips (e.g. one unhealthy replica) so a
    // promo link never dumps the viewer on the home page unnecessarily.
    const attempt = async (n) => {
      try {
        const r = await fetch(url);
        if (r.ok) {
          const d = await r.json();
          if (!cancelled) window.location.replace(d?.url || "/");
          return;
        }
        if (r.status === 404) {
          if (!cancelled) window.location.replace("/");
          return;
        }
        throw new Error(`status ${r.status}`);
      } catch (_e) {
        if (cancelled) return;
        if (n < 4) setTimeout(() => attempt(n + 1), 900 * (n + 1));
        else window.location.replace("/");
      }
    };
    attempt(0);
    return () => { cancelled = true; };
  }, [slug]);
  return null;
}
